<template>
    <CompassEmptyState
        illustrationPath="/ressources/logged/img/illustrations/no-results.svg"
        :caption="translations.caption"
    >
        <CompassButton
            :label="translations.actions.reset_filters"
            @click="$emit('reset-filters')"
        />
    </CompassEmptyState>
</template>

<script>
export default {
    emits: ['reset-filters'],
    data() {
        return {
            translations: {
                caption: this.$t.__('common.labels.caption_no_filter_result'),
                actions: {
                    reset_filters: this.$t.__('common.actions.reset'),
                },
            },
        };
    },
};
</script>
